import { mergeStyleSets } from '@uifabric/merge-styles';
import get from 'lodash/get';
import theme from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  loadingSpinner: {
    marginLeft: pxToRem(10),
  },
  uploader: {
    display: 'none',
  },
  addAttachmentButton: {
    selectors: {
      '& .ms-Button--action, .ms-Button-icon': {
        color: theme.palette.themePrimary,
      },
    },
  },
  allowedAttachments: {
    color: theme.palette.themePrimary,
  },
  transparentBackground: {
    backgroundColor: 'transparent',
    ':active': {
      backgroundColor: 'transparent',
    },
    ':hover': {
      backgroundColor: 'transparent',
    },
  },
  attachmentDeleteIcon: {
    cursor: 'pointer',
    opacity: 0.85,
    ':hover': {
      opacity: 1,
    },
    color: theme.palette.neutralSecondary,
    selectors: {
      '.ms-Button-icon': {
        fontSize: pxToRem(12),
      },
    },
  },
  attachmentDeleteIconDisabled: {
    cursor: 'wait',
    ':hover': {
      opacity: 0.85,
    },
  },
  iconColumnHeader: {
    selectors: {
      '& .ms-DetailsHeader-cellName': {
        height: pxToRem(20),
        width: pxToRem(20),
        textAlign: 'center',
        fontSize: '1rem',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
      },
    },
  },
  headerIcon: {
    maxHeight: pxToRem(16),
    maxWidth: pxToRem(16),
    fontSize: '1rem',
    verticalAlign: 'middle',
  },
  attachmentMsg: {
    paddingTop: pxToRem(6),
    paddingBottom: pxToRem(6),
    paddingRight: pxToRem(10),
    borderBottom: `1px solid ${theme.palette.neutralLight}`,
    fontFamily: get(theme, 'fonts.small.fontFamily'),
    fontSize: pxToRem(14),
    lineHeight: pxToRem(24),
  },
  infoIcon: {
    verticalAlign: 'middle',
    fontSize: pxToRem(16),
    paddingRight: pxToRem(6),
  },
  submitButton: {
    float: 'right',
    padding: `${pxToRem(20)} ${pxToRem(6)} ${pxToRem(6)}`,
  },
  uploadInfoIcon: {
    paddingRight: pxToRem(6),
    color: theme.palette.neutralTertiary,
    verticalAlign: 'middle',
    fontSize: pxToRem(13),
  },
  uploadInfoText: {
    paddingTop: pxToRem(8),
    fontWeight: 'normal',
  },
  infoMsgIcon: {
    position: 'relative',
    fontSize: pxToRem(14),
    color: theme.palette.themePrimary,
  },
  alignCenter: {
    justifyContent: 'center',
  },
});
